import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const SettingsAndCreatorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${spacing.plusHalf};

  @media screen and (max-width: ${pxToRem(893)}) {
    width: 100%;
  }
  @media screen and (min-width: ${pxToRem(894)}) {
    max-width: ${pxToRem(720)};
  }
`;
